const styles = {
  searchContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '1rem',
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 12px rgba(10, 16, 68, 0.08)',
    mb: 2,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    width: '100%',
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    height: '49px',
    justifyContent: 'flex-end',
  },
  clearButton: {
    box: {
      alignSelf: 'center',
    },
    button: {
      color: 'primary.main',
      fontSize: '0.75rem',
      padding: '1rem 0.5rem',
      whiteSpace: 'nowrap',
    },
  },
};

export default styles;
